import React from "react";
import { User } from "../../../types";

const DefaultPlayerMeta = (player: any): any => {
	let metaArray = [];
	if (player.city) {
		metaArray.push(
			<span className="mr-1" key={player.userId + "city-rating"}>
				{player.city}
				{player.rating?.ratingValue || player.rating?.ITNName ? "," : null}
			</span>
		);
	}
	if (player.rating?.ratingValue) {
		if (player.rating?.officialRating) {
			metaArray.push(<div className="icon verified mr-1" key={player.userId + "verified-icon"}></div>);
		}
		metaArray.push(player.rating.ratingValue);
	} else if (player.rating?.ITNName) {
		metaArray.push(player.rating.ITNName);
	}
	return metaArray;
};

export default DefaultPlayerMeta;
